/* VDA motion layer: scroll reveal for below-the-fold sections and cards. No network, storage or cookies. */
(function () {
  var w = window, d = document, io;
  var B = '.scroll-trigger,[class*=yotpo],[id*=yotpo],[class*=loyalty],[id*=loyalty],[class*=swell]';
  var A = 'dialog,[role=dialog],.slider,slider-component,.cart-drawer,' + B;
  var dm = w.Shopify && w.Shopify.designMode;
  function mark(el, i) {
    if (!el.closest('main') || el.closest('.vda-reveal') || el.closest(A) || el.querySelector(B)) return;
    var r = el.getBoundingClientRect();
    if (!dm && (r.height < 1 || r.top < w.innerHeight || r.left >= w.innerWidth || r.height > w.innerHeight * 1.5)) return;
    el.style.setProperty('--vda-i', i % 5);
    el.classList.add('vda-reveal');
    if (dm) el.classList.add('is-in'); else io.observe(el);
  }
  function scan(root) {
    [].forEach.call(d.querySelectorAll('main .shopify-section'), function (s, i) {
      if (i > 1 && (!root || root === s)) mark(s, 0);
    });
    [].forEach.call((root || d).querySelectorAll('.card-wrapper,.collection-card-wrapper'), function (c) {
      var g = c.closest('li') || c;
      mark(c, [].indexOf.call(g.parentNode.children, g));
    });
  }
  try {
    if ((w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches) || !w.IntersectionObserver) return;
    io = new IntersectionObserver(function (list) {
      list.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    scan();
    d.addEventListener('shopify:section:load', function (e) {
      try { scan(e.target); } catch (x) {}
    });
  } catch (x) {
    [].forEach.call(d.querySelectorAll('.vda-reveal'), function (el) { el.classList.add('is-in'); });
  }
})();
